import request from '@/utils/request'

//  用户登录
export const userLogin = (formData) => {
    return request.post('/login', formData)
}

//  微信网页登录
export const weChatLogin = (code) => {
    return request.get(`/weChat/weChatLogin?code=${code}`)
}

//  用户登出
export const userLogout = () => {
    return request.post('/logout')
}

// 俱乐部后台登录
export const userClubLogin = (formData) => {
    return request.post('/login/club', formData)
}

// 商家平台登录
export const merchantLogin = (formData) => {
    return request.post('/merchant/login', formData)
}

// 通过tenantId和adminId-查询有关联合作身份
export const listStoreByTenantId = (pageData, formData) => {
    return request.get(`/merchant/login/tenant/${pageData.page}/${pageData.pageSize}`, {params: formData})
}

// 选择店铺（更新登录信息）
export const merchantChangeStore = (storeId) => {
    return request.put(`/merchant/login/${storeId}`)
}
